import { useState } from 'react';
import { Stack, TextField, InputAdornment, IconButton } from '@mui/material';
import { getIn, useFormikContext } from 'formik';
import FormTextFieldLabel from './FormTextFieldLabel';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

export default function FormTextField({ name, label, outlineLabel = undefined, placeholder, labelRight, onlyAlpha, onlyNumber, onlyFloat, sx, inputSx, children, lowerCase = false, upperCase = false, whiteSpace = false, emptyCheck = false, visibility, setVisibility, forgotPassword = false, allowAlphaNumeric =false, limit = 0, enableLimit = false, onClickForgotPassword, requiredMark, showError = true, onSelect, ...otherProps }) {
  const [blur, setBlur] = useState(true);

  const { values, touched, errors, setFieldValue, handleBlur, dirty } = useFormikContext();

  const onChangeVisibility = () => {
    let val = visibility;
    setVisibility(!val);
  };

  return (
    <Stack sx={{ mb: '22px', ...sx }}>
      {Boolean(label) && (
        <FormTextFieldLabel
          label={label}
          required={requiredMark}
          labelRight={labelRight}
        />
      )}
      <TextField
        sx={{
          '& .MuiInputBase-input': {
            ...inputSx,
          },
        }}
        label={outlineLabel}
        required={requiredMark}
        fullWidth
        autoComplete="off"
        id={name}
        name={name}
        placeholder={placeholder}
        value={getIn(values, name)}
        onChange={(e) => {
          let tempValue = e.target.value;
          if (tempValue && lowerCase) {
            tempValue = tempValue?.toLowerCase()?.trim();
          }
          if (tempValue && upperCase) {
            tempValue = tempValue?.toUpperCase()?.trim();
          }
          if (tempValue && whiteSpace) {
            tempValue = tempValue?.replace(/^\s/g, '');
          }
          if (tempValue && typeof tempValue === 'string') {
            tempValue = tempValue?.trimStart();
          }
          if (tempValue && onlyAlpha) {
            tempValue = tempValue?.replace(/[^a-z\s]/gi, '');
          }
          if (tempValue && allowAlphaNumeric ) {
            tempValue = tempValue?.replace(/[^A-Za-z0-9\s]/gi, '');
          }
          if (tempValue && onlyNumber) {
            tempValue = tempValue?.replace(/[^0-9]/gi, '');
          }
          if (!tempValue) {
            tempValue = '';
          }

          if (tempValue && onlyFloat) {
            if (!tempValue.match(/^([0-9]{1,})?(\.)?([0-9]{1,})?$/)) {
              return;
            }
            if (parseFloat(tempValue) > 99999.99) {
              return;
            }
          }
          setFieldValue(name, tempValue);
          if (onSelect) {
            onSelect(tempValue);
          }
          setBlur(false);
        }}
        onBlur={(e) => {
          handleBlur(e);
          var regex = /^\s*$/;
          if (!regex.test(getIn(values, name))) {
            setBlur(true);
          } else {
            setBlur(false);
          }
        }}
        error={blur && Boolean(getIn(values, name) || emptyCheck) && getIn(touched, name) && Boolean(getIn(errors, name))}
        helperText={blur && showError && Boolean(getIn(values, name) || emptyCheck) && (getIn(touched, name) || dirty[name]) && getIn(errors, name)}
        {...otherProps}
        type={!visibility ? otherProps.type : 'text'}
        InputProps={{
          endAdornment:
            otherProps.type === 'password' ? (
              <InputAdornment position="end">
                {
                  <IconButton
                    onMouseDown={(e) => {
                      e.preventDefault();
                      onChangeVisibility();
                    }}
                  >
                    {visibility ? <VisibilityOutlinedIcon style={{ color: '#8C8C8C', transform: 'scale(0.7274)' }} /> : <VisibilityOffOutlinedIcon style={{ color: '#8C8C8C', transform: 'scale(0.7274)' }} />}
                  </IconButton>
                }
              </InputAdornment>
            ) : (
              ''
            ),
        }}
      >
        {children}
      </TextField>
      {forgotPassword && (
        <FormTextFieldLabel
          forgotPassword={forgotPassword}
          onClickForgotPassword={onClickForgotPassword}
        />
      )}
    </Stack>
  );
}
